import React from "react";
// import Button from "../elements/Button/Button";
import Pricing from "../../components/Pricing/Pricing";
import Logo from "../../components/Common/Logo";
import Topbar from "../../components/Recruiter/Topbar/Topbar";
const Pricingpage = () =>{
    return(
        <>
        <div className="radial-gradient-bg">
            <Topbar/>
            <Pricing />
        </div>
        </>
    )
}
export default Pricingpage;